import {Component} from '@angular/core';
import {CorePage} from "../../../core/page/core-page/core.page";
import {ActivatedRoute} from "@angular/router";
import {InteractionService} from "../../service/interaction.service";

@Component({
    selector: 'ds-tickets-page',
    templateUrl: './interaction.page.html',
})
export class InteractionPage extends CorePage {

    override defaultLabel: string = "Home";

    constructor(
        protected override route: ActivatedRoute,
        protected dashboardService: InteractionService
    ) {
        super(route);

    }

  override ngOnInit() {
    super.ngOnInit();

  }




}
